import React, { useState } from "react";
import Navbar from "../navbar/Navbar";
import Spinner from "../spinner/Spinner";
import "./apartment.css";
import Table from "./table/Table";

function Apartment() {
  const apartments = [
    {
      planImage:
        "https://mirabad.uz/upload/kelnik.estate/b51/b512bef2f489ba078a8028ab9e2440f8.svg",
      info: "2-КОМНАТНАЯ №2",
      additionalInfo: "Вид на шопинг-авеню",
      size: "79.8 м2 / Жилая 46.4 м2",
      floor: "3 этаж из 11",
      zdacha: "Сдача 4 кв 2020",
      moreLink: "#",
    },
    {
      planImage:
        "https://mirabad.uz/upload/kelnik.estate/b51/b512bef2f489ba078a8028ab9e2440f8.svg",
      info: "2-КОМНАТНАЯ №2",
      additionalInfo: "Вид на шопинг-авеню",
      size: "79.8 м2 / Жилая 46.4 м2",
      floor: "3 этаж из 11",
      zdacha: "Сдача 4 кв 2020",
      moreLink: "#",
    },
    {
      planImage:
        "https://mirabad.uz/upload/kelnik.estate/b51/b512bef2f489ba078a8028ab9e2440f8.svg",
      info: "2-КОМНАТНАЯ №2",
      additionalInfo: "Вид на шопинг-авеню",
      size: "79.8 м2 / Жилая 46.4 м2",
      floor: "3 этаж из 11",
      zdacha: "Сдача 4 кв 2020",
      moreLink: "#",
    },
    {
      planImage:
        "https://mirabad.uz/upload/kelnik.estate/b51/b512bef2f489ba078a8028ab9e2440f8.svg",
      info: "2-КОМНАТНАЯ №2",
      additionalInfo: "Вид на шопинг-авеню",
      size: "79.8 м2 / Жилая 46.4 м2",
      floor: "3 этаж из 11",
      zdacha: "Сдача 4 кв 2020",
      moreLink: "#",
    },
    {
      planImage:
        "https://mirabad.uz/upload/kelnik.estate/b51/b512bef2f489ba078a8028ab9e2440f8.svg",
      info: "2-КОМНАТНАЯ №2",
      additionalInfo: "Вид на шопинг-авеню",
      size: "79.8 м2 / Жилая 46.4 м2",
      floor: "3 этаж из 11",
      zdacha: "Сдача 4 кв 2020",
      moreLink: "#",
    },
    {
      planImage:
        "https://mirabad.uz/upload/kelnik.estate/b51/b512bef2f489ba078a8028ab9e2440f8.svg",
      info: "2-КОМНАТНАЯ №2",
      additionalInfo: "Вид на шопинг-авеню",
      size: "79.8 м2 / Жилая 46.4 м2",
      floor: "3 этаж из 11",
      zdacha: "Сдача 4 кв 2020",
      moreLink: "#",
    },
    {
      planImage:
        "https://mirabad.uz/upload/kelnik.estate/b51/b512bef2f489ba078a8028ab9e2440f8.svg",
      info: "2-КОМНАТНАЯ №2",
      additionalInfo: "Вид на шопинг-авеню",
      size: "79.8 м2 / Жилая 46.4 м2",
      floor: "3 этаж из 11",
      zdacha: "Сдача 4 кв 2020",
      moreLink: "#",
    },
  ];

  const blocks = [
    "Блок A",
    "Блок B",
    "Блок C",
    "Блок D",
    "Блок D (ДОМ 13)",
    "Блок D (ДОМ5)",
    "Блок С (ДОМ8)",
  ];

  const ft = ["1 кв. 2021","1 кв 2022","4 кв 2020","4 кв 2020","Сдан","5 балконов","3 балкона","Вид на аллею","2 балкона","4 балкона","Вид на шопинг-авеню","Вид на двор","С террасой","Пентхаус","2 санузла","3 санузла","4 санузла","2 спальни","3 спальни","4 спальни"]

  const [from, setFrom] = useState(35);
  const [floor, setFloor] = useState(1);

  return (
    <>
      <Navbar color={"navbar-light"} logo={"dark"} />

      <section className="apartments-page">
        <br />
        <br />
        <br />
        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-9">
              <h1 className="text-center">ДВУХКОМНАТНЫЕ КВАРТИРЫ В НОВОСТРОЙКЕ</h1>
              <br />
              <div className="container">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Планировка</th>
                      <th scope="col">Квартира</th>
                      <th scope="col">S, м</th>
                      <th scope="col">Этаж</th>
                      <th scope="col">Cдача</th>
                      <th scope="col">Цена, UZS</th>
                    </tr>
                  </thead>
                  {apartments &&
                    apartments.map((e, i) => (
                      <Table
                        planImage={e.planImage}
                        info={e.info}
                        additionalInfo={e.additionalInfo}
                        size={e.size}
                        floor={e.floor}
                        zdacha={e.zdacha}
                        moreLink={e.moreLink}
                      />
                    ))}
                </table>
                {!apartments && <Spinner />}
              </div>
            </div>
            <div className="col-3">
              <div className="container bg-light p-4">
                <div className="room-filter container d-flex justify-content-center">
                  <button className="btn m-2 bg-white">2x</button>
                  <button className="btn m-2 bg-white">3x</button>
                  <button className="btn m-2 bg-white">4x</button>
                  <button className="btn m-2 bg-white">P</button>
                  <button className="btn m-2 bg-white">T</button>
                </div>

                <hr className="divider" />

                <div className="container">
                  <label htmlFor="" className="ml-2">
                    Выберите блок
                  </label>
                  <select
                    className="form-select mt-2"
                    aria-label="Default select example"
                  >
                    {blocks.map((e, i) => (
                      <option>{e}</option>
                    ))}
                  </select>
                  <br />
                  <label htmlFor="">Площадь, м²</label>
                  <br />
                  <br />

                  <h4>{from}m^2</h4>
                  <input
                    type="range"
                    max={200}
                    min={35}
                    onChange={(e) => setFrom(e.target.value)}
                    className="form-range"
                    id="customRange1"
                  ></input>
                  <br />
                  <br />
                  <label htmlFor="">Этаж</label>
                  
                  <br />
                  <br />

                  <h4>{floor}</h4>
                  <input
                    type="range"
                    max={11}
                    min={1}
                    value={floor}
                    onChange={(e) => setFloor(e.target.value)}
                    className="form-range"
                    id="customRange2"
                  ></input>
                  <br />
                  <div className="d-flex ft">
                    {
                        ft.map((e, i)=>(
                            <button className="btn m-1 bg-white">{e}</button>
                        ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Apartment;
